import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import type { FetchReviewMessagesSuccessResponse } from '../../types/api/response/reviewMessage'
import type { MessageType } from '../../types/model/reviewMessage'
import { filterNonNullQueryParams } from '@/modules/Core/utils'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'review-messages'
const ENDPOINT = '/ReviewMessage'

export function fetchReviewMessages(
  type: MessageType,
  query: string,
  page: number,
  size: number,
  sortOrder: SortOrder
) {
  const params = filterNonNullQueryParams({
    type,
    query,
    page,
    size,
    sortOrder,
  })
  return axiosInstance
    .get<FetchReviewMessagesSuccessResponse>(ENDPOINT, {
      params,
    })
    .then((data) => data.data)
}

export function useReviewMessagesQuery(
  type: Ref<MessageType>,
  query: Ref<string>,
  page: Ref<number>,
  size: Ref<number>,
  sortOrder: Ref<SortOrder>,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchReviewMessages>>>
) {
  return useQuery({
    queryFn: () =>
      fetchReviewMessages(
        type.value,
        query.value,
        page.value,
        size.value,
        sortOrder.value
      ),
    queryKey: [QUERY_KEY, type, query, page, size, sortOrder],
    ...options,
  })
}
